import { render, staticRenderFns } from "./account-resource-item-1-statistics.vue?vue&type=template&id=dcc87db8&"
import script from "./account-resource-item-1-statistics.vue?vue&type=script&lang=ts&"
export * from "./account-resource-item-1-statistics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports